import { Add } from '@mui/icons-material'
import { Button, CircularProgress, Menu, MenuItem, Switch } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { FaChevronDown } from 'react-icons/fa6';
import AddNotificationModal from './components/AddNotificationModal';
import DeleteNotification from './components/DeleteNotification';
import { useAppServices } from 'hook/services';


const NotificationBanner = ({ agency, Update }) => {
    const Service = useAppServices();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [isOpen, setIsOpen] = useState(false)
    const [openDeleteModel, setOpenDeleteModal] = useState(false)
    const [editNotification, setEditNotification] = useState(null);
    const [loading, setLoading] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')


    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setEditNotification(item);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    }

    function formatEndDate(dateString) {
        if (!dateString) return "";

        const date = new Date(dateString);
        const day = date.getDate();

        const monthYear = new Intl.DateTimeFormat("en-US", {
            month: "long",
            year: "numeric",
        }).format(date);

        return `${monthYear.split(" ")[0]} ${day}${getOrdinalSuffix(day)}, ${date.getFullYear()}`;
    }

    const handleUpdateStatus = async (item, idx) => {
        const enabledCount = agency.notifications.filter(n => n.status === true).length;
        const currentNotification = agency.notifications.find(n => n.id === item);
        if (!currentNotification.status && enabledCount >= 3) {
            setErrorMessage('Maximum of 3 notifications');
            setTimeout(() => {
                setErrorMessage('');
            }, 2000);
            return;
        }

        setLoading(idx);
        const notifications = agency.notifications.map(n => {
            if (n.id === item) {
                return { ...n, status: !n.status };
            }
            return n;
        });
        const payload = {
            notifications: notifications,
            _id: agency._id
        }
        const { response } = await Service.agency.update({ payload });
        if (response?.success) {
            Update({ notifications });
        } else {
            alert("Failed to update Notifications")
        }
        setLoading(null);
    }

    const changeStatusOnLoad = async () => {
        if (agency?.notifications?.filter(item => item.status && (item.endDate === null || new Date(item.endDate) >= new Date())?.length > 0)) {
            const notifications = agency.notifications?.map(item => ({ ...item, status: item.status && (item.endDate === null || new Date(item.endDate) >= new Date()) }))
            const payload = {
                notifications: notifications,
                _id: agency._id
            }
            const { response } = await Service.agency.update({ payload });
            if (response?.success) {
                Update({ notifications });
            } else {
                alert("Failed to update Notifications")
            }
        }
    }

    useEffect(() => {
        changeStatusOnLoad()
    }, [])

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "end", fontFamily: "Inter", marginBottom: "10px" }}>
                <button onClick={() => setIsOpen(true)} style={{ padding: "12px 20px", gap: "4px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px", fontWeight: "600", background: "#000", color: "white", borderRadius: "3px", border: "none" }}><Add /> <span>New Notification</span></button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {agency?.notifications?.map((item, idx) => {
                    return (
                        <div key={item.id} style={{ border: "2px solid #e6e4e4ff", borderRadius: "10px", padding: "20px 30px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div>
                                <p style={{ fontSize: "15px", fontFamily: "Inter", fontWeight: "600", color: "#7a7a7aff" }}>{item.category?.toUpperCase()}</p>
                                <p style={{ fontSize: "16px", fontFamily: "Inter", fontWeight: "600", color: "#000" }}>{item.title}</p>
                                {item.endDate && <p style={{ fontSize: "16px", fontFamily: "Inter", color: "#7a7a7aff" }}>End: {formatEndDate(item.endDate)}</p>}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                {loading && loading === idx ? <CircularProgress size={24} /> : <Switch onChange={() => { handleUpdateStatus(item.id, idx) }} checked={item.status} sx={{
                                    "& .MuiSwitch-switchBase": {
                                        "&.Mui-checked": {
                                            color: "#000 !important",
                                            "& + .MuiSwitch-track": {
                                                backgroundColor: "#000 !important",
                                                opacity: 1,
                                            },
                                        },
                                    },
                                }} />}
                                <div>
                                    <Button
                                        id="basic-button"
                                        aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={(e) => handleClick(e, item)}
                                        sx={{
                                            color: "#000",
                                            "&:hover": {
                                                color: "#000",
                                            }
                                        }}
                                    >
                                        <FaChevronDown />
                                    </Button>
                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        slotProps={{
                                            list: {
                                                'aria-labelledby': 'basic-button',
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={() => { setIsOpen(true); handleClose() }} sx={{ color: "#000", "&:hover": { color: "#000 !important" } }}>Edit</MenuItem>
                                        <MenuItem onClick={() => { setOpenDeleteModal(true); handleClose() }} sx={{ color: "rgba(234, 26, 26, 1)", "&:hover": { color: "rgba(234, 26, 26, 1) !important" } }}>Delete</MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            {isOpen && <AddNotificationModal open={isOpen} onClose={() => { setIsOpen(false); setEditNotification(null); }} editNotification={editNotification} agency={agency} Update={Update} />}
            {openDeleteModel && <DeleteNotification open={openDeleteModel} onClose={() => { setOpenDeleteModal(false); setEditNotification(null); }} editNotification={editNotification} agency={agency} Update={Update} />}

            {/* Error Message Banner */}
            {errorMessage && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    padding: '16px 24px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 9999,
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '600',
                    animation: 'slideIn 0.3s ease-out'
                }}>
                    <div style={{ marginBottom: '4px' }}>{errorMessage}</div>
                    <div style={{ fontSize: '12px', fontWeight: '400', opacity: 0.9 }}>
                        Disable one to continue.
                    </div>
                </div>
            )}

            <style>{`
                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    )
}

export default NotificationBanner